import { useIsomorphicLayoutEffect } from "@tamagui/constants";
import { useRef } from "react";
const useSafeRef = (initialValue) => {
  const rawRef = useRef();
  if (!rawRef.current) {
    rawRef.current = {
      hold: true,
      next: initialValue,
      cur: initialValue,
      ref: {
        get current() {
          return raw.hold ? raw.cur : raw.next;
        },
        set current(v) {
          if (!raw.hold) {
            raw.next = v;
          }
          raw.cur = v;
        }
      }
    };
  }
  const raw = rawRef.current;
  raw.hold = true;
  raw.cur = raw.next;
  useIsomorphicLayoutEffect(() => {
    raw.hold = false;
    raw.next = raw.cur;
  });
  return raw.ref;
};
export {
  useSafeRef
};
//# sourceMappingURL=useSafeRef.js.map
